export default "__VITE_PUBLIC_ASSET__eacf489a__"